import { LinearProgress, Typography } from '@mui/material';
import React, { memo } from 'react';

interface Props {
  label: string;
  value: number;
  className?: string;
}

const Component: React.FC<Props> = ({ label, value, className }) => {
  return (
    <div className={className}>
      <Typography
        color="var(--text-3-color)"
        display="block"
        lineHeight="12px"
        mb="8px"
        textAlign="center"
        variant="caption"
      >
        <Typography
          color="var(--text-3-color)"
          component="span"
          fontWeight="700"
          lineHeight="14px"
          variant="subtitle2"
        >
          {value}%
        </Typography>{' '}
        {label}
      </Typography>
      <LinearProgress value={value} variant="determinate" />
    </div>
  );
};

export const ProgressBar = memo(Component);
